// tslint:disable:max-line-length

import React from 'react';

export const ArrowLeftSmall = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 16 16" {...props}>
      <polygon points="7.33 14 2 8 7.33 2 7.96 2.71 3.7 7.5 14 7.5 14 8.5 3.7 8.5 7.96 13.29 7.33 14 7.33 14" />
    </svg>
  );
};
